import { AngularFirestore, DocumentReference } from '@angular/fire/firestore';
import { AuthUserService } from '../auth/auth-user.service';
import { Comment, Comments } from './comment.model';
import { Injectable } from '@angular/core';
import { NfmbDataService } from '../nfmb-data.service';
import { Observable } from 'rxjs';
import { Profiles } from '../profiles/profile.model';
import { switchMap, first, shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CommentService extends NfmbDataService {

  constructor(
    afs: AngularFirestore,
    authUserService: AuthUserService
  ) {
    super(afs, authUserService, 'comments');

    this.permissions = {
      edit: [
        Profiles.Role.ROOT,
        Profiles.Role.ADMIN,
        Profiles.Role.EDITOR
      ],
      delete: [
        Profiles.Role.ROOT,
        Profiles.Role.ADMIN
      ],
      read: [
        Profiles.Role.ROOT,
        Profiles.Role.ADMIN,
        Profiles.Role.EDITOR,
        Profiles.Role.READER
      ],
      viewAll: [
        Profiles.Role.ROOT,
        Profiles.Role.ADMIN
      ]
    };
  }

  get data$(): Observable<any> {
    return this.authUserService.currentProfile$.pipe(
      switchMap( profile => {
        if (profile) {
          return this.afs.collection<Comment>(this.collectionPath,
            ref => {
              console.log('Comment Stream emit new value for following profile: ', profile);

              let query: firebase.firestore.CollectionReference | firebase.firestore.Query = ref;
              query = query.where('organizationId', '==', profile.organizationId);
              query = query.orderBy(Comments.IndexField.PUBLISHED_AT, 'desc');
              return query;
            }
          ).valueChanges({ idField: 'id' });
        } else {
          return [];
        }
      }),
      shareReplay(1)
    );
  }

  async push(item: any): Promise<DocumentReference> {
    const currentProfile = await this.authUserService.currentProfile$.pipe(first()).toPromise();
    if (!(currentProfile && currentProfile.organizationId)) {
      return Promise.reject('user not authorized');
    }
    const timestamp = this.timestamp;
    return this.afs.collection<Comment>(this.collectionPath).add({
      ...item,
      author: currentProfile,
      organizationId: currentProfile.organizationId,
      createdAt: timestamp,
      modifiedAt: timestamp
    });
  }
}
